import React, { useState } from "react";

interface Props {
  rating: "thumbs_up" | "thumbs_down";
  onSubmit: (feedbackText: string) => void;
  onClose: () => void;
}

const FeedbackModal: React.FC<Props> = ({ rating, onSubmit, onClose }) => {
  const [text, setText] = useState("");

  const title =
    rating === "thumbs_up" ? "Thanks for the feedback!" : "Thanks for letting us know";
  const subtitle =
    rating === "thumbs_up"
      ? "Any additional comments? (optional)"
      : "How could the answer be improved? (optional)";

  return (
    <div className="absolute inset-0 bg-black/50 flex items-center justify-center p-4 z-10">
      <div className="bg-white rounded-2xl p-5 w-full max-w-sm shadow-xl">
        <h3 className="text-sm font-semibold text-[#090F21] mb-1">{title}</h3>
        <p className="text-[11px] text-gray-500 mb-3">{subtitle}</p>
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Your feedback helps us improve..."
          rows={3}
          className="w-full bg-gray-50 rounded-lg py-2 px-3 text-[11px] font-medium border border-gray-200 outline-none focus:ring-1 focus:ring-[#090F21] placeholder:text-gray-400 transition-all resize-none"
        />
        <div className="mt-4 flex gap-2 justify-end">
          <button
            type="button"
            onClick={onClose}
            className="px-3 py-1.5 text-[11px] font-medium text-gray-500 hover:text-gray-700 transition-colors"
          >
            Skip
          </button>
          <button
            type="button"
            onClick={() => onSubmit(text)}
            className="!bg-[#090F21] text-white text-[11px] font-medium px-4 py-1.5 rounded-lg hover:!bg-[#1a2540] active:scale-95 transition-all"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
